import type {
    ComponentStageData,
    MobileAlgoPlugin,
    MobileAlgoPluginInitializationArgs,
    PluginHeuristicsRegistry
} from '../../types'
import {backgroundComponentsHeuristics} from './heuristicDefinition'

export const createPlugin = ({stages}: MobileAlgoPluginInitializationArgs): MobileAlgoPlugin => {
    const organizeBackgroundComponents = (componentStageData: ComponentStageData) => {
        const heuristicToApply = backgroundComponentsHeuristics.find(({predicate}) => predicate(componentStageData))!

        if (!heuristicToApply) {
            return
        }

        heuristicToApply.apply(componentStageData)

        return {
            appliedHeuristics: ['MOVE BACKGROUND COMPONENTS']
        }
    }

    const register = (registry: PluginHeuristicsRegistry) => {
        registry.register(stages.COMPONENT_CATEGORIZATION, organizeBackgroundComponents)
    }

    return {register, name: 'backgroundComponents', dependencies: []}
}
